import { setState } from './helpers'

const miscMutations = {
  SET_ABOUT_LIST: setState('abouts'),
  SET_ABOUT: setState('about'),
  SET_CONTACT_SERVICES: setState('contactServices'),
  SET_CONTACT_SERVICE: setState('contactService')
}

export { miscMutations }
